import { startsWith, prop, propEq, find } from "ramda";
import qs from "qs";

export const getCurrentDataKey = location =>
  startsWith("/map", location.pathname) &&
  qs.parse(location.search, { ignoreQueryPrefix: true }).key;

export const getSelectedIndicator = (location, indicators) => {
  return find(propEq("dataKey", getCurrentDataKey(location)), indicators);
};



// WEBPACK FOOTER //
// ./src/utils.js